import { render, staticRenderFns } from "./Container.vue?vue&type=template&id=5aa4d9c9"
import script from "./Container.vue?vue&type=script&setup=true&lang=js"
export * from "./Container.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5aa4d9c9')) {
      api.createRecord('5aa4d9c9', component.options)
    } else {
      api.reload('5aa4d9c9', component.options)
    }
    module.hot.accept("./Container.vue?vue&type=template&id=5aa4d9c9", function () {
      api.rerender('5aa4d9c9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/shared/components/Container.vue"
export default component.exports